<template>
  <div v-if="update" class="hidden sm:flex h-dvh w-screen absolute inset-0 items-end justify-end z-80000 pointer-events-none p-4">
    <div class="w-80 bg-white dark:bg-gray-900 rounded-xl overflow-hidden relative flex flex-col border border-gray-200 dark:border-gray-800 pointer-events-auto">
      <div
        v-if="update.imageUrls"
        class="w-full flex-shrink bg-cover h-48 bg-center"
        :style="{
          backgroundImage: `url(${update.imageUrls.large})`
        }"
      />

      <button class="bg-white/15 rounded-full flex items-center justify-center h-5 w-5 absolute top-0 right-0 m-2 text-white hover:bg-white/25" @click="handleDismiss">
        <o-icon icon="x" />
      </button>

      <div class="p-3 text-left">
        <h3 class="font-medium opacity-90">
          {{ update.subject }}
        </h3>
        <p v-if="update.header" class="opacity-70 mt-2">
          {{ update.header }}
        </p>
      </div>

      <div class="flex items-center space-x-2 p-3">
        <o-button variant="primary" @click="handleOpen">
          {{ $t('general.readMore') }}
        </o-button>

        <o-button outline @click="update = null">
          {{ $t('components.layout.update.remindMeLater') }}
        </o-button>

        <o-button outline @click="handleDismiss">
          {{ $t('components.layout.update.dismiss') }}
        </o-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $api } = useNuxtApp()

const update = ref<any>(null)

const fetchUnreadUpdates = async () => {
  try {
    const response = await $api.update.unread()

    if (response?.items?.[0]) {
      update.value = response.items[0]
    }
  } catch (e) {
    console.log(e)
  }
}

const handleOpen = () => {
  const slug = update.value?.slug
  const section = update.value?.isUpdateTypeReleaseNotes ? 'changelog' : 'updates'
  const url = `https://ovatu.com/au/${section}/${slug}`

  window.open(url, '_blank')

  handleDismiss()
}

const handleDismiss = async () => {
  update.value = null

  try {
    await $api.update.markAsRead()
  } catch (e) {
    console.log(e)
  }
}

onMounted(() => {
  fetchUnreadUpdates()
})
</script>
